module.exports = __webpack_public_path__ + "img/icon-2.7974e7ec.png";